"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rangesOverlaps = exports.getDayLabel = exports.set = exports.setDayOfWeek = exports.getListOfMonths = exports.formatDate = exports.toMidnight = exports.isSameDay = exports.differenceInDays = exports.calculateDifference = exports.getMinutes = exports.getHours = exports.endOfQuarter = exports.endOfMonth = exports.endOfWeek = exports.endOfDay = exports.startOfQuarter = exports.startOfMonth = exports.startOfWeek = exports.startOfDay = exports.isSameMonth = exports.isSameYear = exports.endOfYear = exports.startOfYear = exports.isSameOrAfter = exports.isSameOrBefore = exports.isBefore = exports.isAfter = exports.dateToPrecision = exports.isBetween = exports.setYear = exports.getYear = exports.addYears = exports.addQuarters = exports.addMonths = exports.addWeeks = exports.subDays = exports.addDays = exports.isDate = exports.toDate = exports.removeUTCZuluFromDateObject = exports.removeUTCZuluFromDateTimestamp = exports.getDateDayKey = exports.isDayKey = exports.dayKeys = exports.DATE_FORMATS = void 0;
const tslib_1 = require("tslib");
const addDays_1 = tslib_1.__importDefault(require("date-fns/addDays"));
const addMonths_1 = tslib_1.__importDefault(require("date-fns/addMonths"));
const addQuarters_1 = tslib_1.__importDefault(require("date-fns/addQuarters"));
const addWeeks_1 = tslib_1.__importDefault(require("date-fns/addWeeks"));
const addYears_1 = tslib_1.__importDefault(require("date-fns/addYears"));
const differenceInDays_1 = tslib_1.__importDefault(require("date-fns/differenceInDays"));
const differenceInMilliseconds_1 = tslib_1.__importDefault(require("date-fns/differenceInMilliseconds"));
const differenceInMinutes_1 = tslib_1.__importDefault(require("date-fns/differenceInMinutes"));
const differenceInSeconds_1 = tslib_1.__importDefault(require("date-fns/differenceInSeconds"));
const eachMonthOfInterval_1 = tslib_1.__importDefault(require("date-fns/eachMonthOfInterval"));
const endOfDay_1 = tslib_1.__importDefault(require("date-fns/endOfDay"));
const endOfMonth_1 = tslib_1.__importDefault(require("date-fns/endOfMonth"));
const endOfQuarter_1 = tslib_1.__importDefault(require("date-fns/endOfQuarter"));
const endOfWeek_1 = tslib_1.__importDefault(require("date-fns/endOfWeek"));
const endOfYear_1 = tslib_1.__importDefault(require("date-fns/endOfYear"));
const format_1 = tslib_1.__importDefault(require("date-fns/format"));
const getHours_1 = tslib_1.__importDefault(require("date-fns/getHours"));
const getMinutes_1 = tslib_1.__importDefault(require("date-fns/getMinutes"));
const getYear_1 = tslib_1.__importDefault(require("date-fns/getYear"));
const isAfter_1 = tslib_1.__importDefault(require("date-fns/isAfter"));
const isBefore_1 = tslib_1.__importDefault(require("date-fns/isBefore"));
const isDate_1 = tslib_1.__importDefault(require("date-fns/isDate"));
const isEqual_1 = tslib_1.__importDefault(require("date-fns/isEqual"));
const isSameDay_1 = tslib_1.__importDefault(require("date-fns/isSameDay"));
const isSameMonth_1 = tslib_1.__importDefault(require("date-fns/isSameMonth"));
const isSameYear_1 = tslib_1.__importDefault(require("date-fns/isSameYear"));
const max_1 = tslib_1.__importDefault(require("date-fns/max"));
const min_1 = tslib_1.__importDefault(require("date-fns/min"));
const set_1 = tslib_1.__importDefault(require("date-fns/set"));
const setYear_1 = tslib_1.__importDefault(require("date-fns/setYear"));
const startOfDay_1 = tslib_1.__importDefault(require("date-fns/startOfDay"));
const startOfHour_1 = tslib_1.__importDefault(require("date-fns/startOfHour"));
const startOfMinute_1 = tslib_1.__importDefault(require("date-fns/startOfMinute"));
const startOfMonth_1 = tslib_1.__importDefault(require("date-fns/startOfMonth"));
const startOfQuarter_1 = tslib_1.__importDefault(require("date-fns/startOfQuarter"));
const startOfSecond_1 = tslib_1.__importDefault(require("date-fns/startOfSecond"));
const startOfWeek_1 = tslib_1.__importDefault(require("date-fns/startOfWeek"));
const startOfYear_1 = tslib_1.__importDefault(require("date-fns/startOfYear"));
const subDays_1 = tslib_1.__importDefault(require("date-fns/subDays"));
exports.DATE_FORMATS = {
  BE_FORMAT: 'yyyy-MM-dd HH:mm:ss',
  DATE_FORMAT_LONG: 'yyyy-MM-ddTHH:mm:ss',
  YEAR_MONTH_DAY_FORMAT: 'yyyy-MM-dd',
  YEAR_MONTH: 'yyyy-MM',
  MONTH_DAY: 'MM-dd',
  YEAR_FORMAT: 'yyyy',
  MONTH_YEAR: 'MMMM yyyy',
  MONTH_SHORT: 'MMM',
  MONTH_SHORT_DAY: 'MMM d',
  MONTH_DAY_YEAR: 'MMM do yyyy',
  DAY_INDEX_OF_WEEK: 'i',
  DAY_SHORT: 'EEE',
  DAY_LONG: 'EEEE',
  WEEK_SHORT_MONTH_SHORT_DAY: 'EEE, LLL d'
};
exports.dayKeys = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const isDayKey = text => {
  return exports.dayKeys.includes(text);
};
exports.isDayKey = isDayKey;
const getDateDayKey = dateLike => {
  const date = (0, exports.toDate)(dateLike);
  const index = Number.parseInt((0, exports.formatDate)(date, exports.DATE_FORMATS.DAY_INDEX_OF_WEEK)) - 1;
  return exports.dayKeys[index];
};
exports.getDateDayKey = getDateDayKey;
const removeUTCZuluFromDateTimestamp = date => {
  if (typeof date === 'object' && 'value' in date) {
    return new Date(date.value);
  } else if ('string' !== typeof date) {
    return date;
  }
  return date.replace('Z', '');
};
exports.removeUTCZuluFromDateTimestamp = removeUTCZuluFromDateTimestamp;
const removeUTCZuluFromDateObject = dateLike => {
  const date = (0, exports.toDate)(dateLike);
  return new Date((0, exports.removeUTCZuluFromDateTimestamp)(date.toISOString()));
};
exports.removeUTCZuluFromDateObject = removeUTCZuluFromDateObject;
const toDate = date => {
  if (!date) {
    return new Date();
  } else if (typeof date === 'object' && 'value' in date) {
    return new Date(date.value);
  } else if (!(date instanceof Date)) {
    return new Date(date);
  } else {
    return date;
  }
};
exports.toDate = toDate;
const isDate = date => {
  return (0, isDate_1.default)(date);
};
exports.isDate = isDate;
const addDays = (date, days) => {
  return (0, addDays_1.default)((0, exports.toDate)(date), days);
};
exports.addDays = addDays;
const subDays = (date, days) => {
  return (0, subDays_1.default)((0, exports.toDate)(date), days);
};
exports.subDays = subDays;
const addWeeks = (date, weeks) => {
  return (0, addWeeks_1.default)((0, exports.toDate)(date), weeks);
};
exports.addWeeks = addWeeks;
const addMonths = (date, months) => {
  return (0, addMonths_1.default)((0, exports.toDate)(date), months);
};
exports.addMonths = addMonths;
const addQuarters = (date, quarters) => {
  return (0, addQuarters_1.default)((0, exports.toDate)(date), quarters);
};
exports.addQuarters = addQuarters;
const addYears = (date, years) => {
  return (0, addYears_1.default)((0, exports.toDate)(date), years);
};
exports.addYears = addYears;
const getYear = dateLike => {
  return (0, getYear_1.default)((0, exports.toDate)(dateLike));
};
exports.getYear = getYear;
const setYear = (dateLike, year) => {
  return (0, setYear_1.default)((0, exports.toDate)(dateLike), year);
};
exports.setYear = setYear;
const isBetween = function (dateLike, startDateLike, endDateLike) {
  let inclusive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  const date = (0, exports.toDate)(dateLike);
  const startDate = (0, exports.toDate)(startDateLike);
  const endDate = (0, exports.toDate)(endDateLike);
  if (inclusive) {
    return ((0, isEqual_1.default)(date, startDate) || (0, isAfter_1.default)(date, startDate)) && ((0, isEqual_1.default)(date, endDate) || (0, isBefore_1.default)(date, endDate));
  } else {
    return (0, isAfter_1.default)(date, startDate) && (0, isBefore_1.default)(date, endDate);
  }
};
exports.isBetween = isBetween;
const dateToPrecision = (date, precision) => {
  if (!precision) {
    return date;
  }
  let normalizedDate = date;
  switch (precision) {
    case 'second':
      normalizedDate = (0, startOfSecond_1.default)(date);
      break;
    case 'minute':
      normalizedDate = (0, startOfMinute_1.default)(date);
      break;
    case 'hour':
      normalizedDate = (0, startOfHour_1.default)(date);
      break;
    case 'day':
      normalizedDate = (0, startOfDay_1.default)(date);
      break;
  }
  return normalizedDate;
};
exports.dateToPrecision = dateToPrecision;
const isAfter = (dateLeftLike, dateRightLike, precision) => {
  const dateLeft = (0, exports.dateToPrecision)((0, exports.toDate)(dateLeftLike), precision);
  const dateRight = (0, exports.dateToPrecision)((0, exports.toDate)(dateRightLike), precision);
  return (0, isAfter_1.default)(dateLeft, dateRight);
};
exports.isAfter = isAfter;
const isBefore = (dateLeftLike, dateRightLike, precision) => {
  const dateLeft = (0, exports.dateToPrecision)((0, exports.toDate)(dateLeftLike), precision);
  const dateRight = (0, exports.dateToPrecision)((0, exports.toDate)(dateRightLike), precision);
  return (0, isBefore_1.default)(dateLeft, dateRight);
};
exports.isBefore = isBefore;
const isSameOrBefore = (dateLeftLike, dateRightLike, precision) => {
  const dateLeft = (0, exports.dateToPrecision)((0, exports.toDate)(dateLeftLike), precision);
  const dateRight = (0, exports.dateToPrecision)((0, exports.toDate)(dateRightLike), precision);
  return (0, isEqual_1.default)(dateLeft, dateRight) || (0, isBefore_1.default)(dateLeft, dateRight);
};
exports.isSameOrBefore = isSameOrBefore;
const isSameOrAfter = (dateLeftLike, dateRightLike, precision) => {
  const dateLeft = (0, exports.dateToPrecision)((0, exports.toDate)(dateLeftLike), precision);
  const dateRight = (0, exports.dateToPrecision)((0, exports.toDate)(dateRightLike), precision);
  return (0, isEqual_1.default)(dateLeft, dateRight) || (0, isAfter_1.default)(dateLeft, dateRight);
};
exports.isSameOrAfter = isSameOrAfter;
const startOfYear = dateLike => {
  return (0, startOfYear_1.default)((0, exports.toDate)(dateLike));
};
exports.startOfYear = startOfYear;
const endOfYear = dateLike => {
  return (0, endOfYear_1.default)((0, exports.toDate)(dateLike));
};
exports.endOfYear = endOfYear;
const isSameYear = (dateLeft, dateRight) => {
  const left = (0, exports.toDate)(dateLeft);
  const right = (0, exports.toDate)(dateRight);
  return (0, isSameYear_1.default)(left, right);
};
exports.isSameYear = isSameYear;
const isSameMonth = (dateLeft, dateRight) => {
  const left = (0, exports.toDate)(dateLeft);
  const right = (0, exports.toDate)(dateRight);
  return (0, isSameMonth_1.default)(left, right);
};
exports.isSameMonth = isSameMonth;
const startOfDay = dateLike => {
  const date = (0, exports.toDate)(dateLike);
  return (0, startOfDay_1.default)(date);
};
exports.startOfDay = startOfDay;
const startOfWeek = function (dateLike) {
  let weekStartsOn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const date = (0, exports.toDate)(dateLike);
  return (0, startOfWeek_1.default)(date, {
    weekStartsOn
  });
};
exports.startOfWeek = startOfWeek;
const startOfMonth = dateLike => {
  const date = (0, exports.toDate)(dateLike);
  return (0, startOfMonth_1.default)(date);
};
exports.startOfMonth = startOfMonth;
const startOfQuarter = dateLike => {
  const date = (0, exports.toDate)(dateLike);
  return (0, startOfQuarter_1.default)(date);
};
exports.startOfQuarter = startOfQuarter;
const endOfDay = dateLike => {
  const date = (0, exports.toDate)(dateLike);
  return (0, endOfDay_1.default)(date);
};
exports.endOfDay = endOfDay;
const endOfWeek = function (dateLike) {
  let weekStartsOn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const date = (0, exports.toDate)(dateLike);
  return (0, endOfWeek_1.default)(date, {
    weekStartsOn
  });
};
exports.endOfWeek = endOfWeek;
const endOfMonth = dateLike => {
  const date = (0, exports.toDate)(dateLike);
  return (0, endOfMonth_1.default)(date);
};
exports.endOfMonth = endOfMonth;
const endOfQuarter = dateLike => {
  const date = (0, exports.toDate)(dateLike);
  return (0, endOfQuarter_1.default)(date);
};
exports.endOfQuarter = endOfQuarter;
const getHours = dateLike => {
  const date = (0, exports.toDate)(dateLike);
  return (0, getHours_1.default)(date);
};
exports.getHours = getHours;
const getMinutes = dateLike => {
  const date = (0, exports.toDate)(dateLike);
  return (0, getMinutes_1.default)(date);
};
exports.getMinutes = getMinutes;
const calculateDifference = function (leftDateLike, rightDateLike) {
  let precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
  const dateLeft = (0, exports.toDate)(leftDateLike);
  const dateRight = (0, exports.toDate)(rightDateLike);
  switch (precision) {
    case 'day':
      return (0, differenceInDays_1.default)(dateLeft, dateRight);
    case 'minute':
      return (0, differenceInMinutes_1.default)(dateLeft, dateRight);
    case 'second':
      return (0, differenceInSeconds_1.default)(dateLeft, dateRight);
    case 'millisecond':
      return (0, differenceInMilliseconds_1.default)(dateLeft, dateRight);
  }
  return (0, differenceInDays_1.default)(dateLeft, dateRight);
};
exports.calculateDifference = calculateDifference;
const differenceInDays = (startDateLike, endDateLike) => {
  const startDate = (0, exports.toDate)(startDateLike);
  const endDate = (0, exports.toDate)(endDateLike);
  return (0, differenceInDays_1.default)(endDate, startDate);
};
exports.differenceInDays = differenceInDays;
const isSameDay = (leftDateLike, rightDateLike) => {
  const dateLeft = (0, exports.toDate)(leftDateLike);
  const dateRight = (0, exports.toDate)(rightDateLike);
  return (0, isSameDay_1.default)(dateLeft, dateRight);
};
exports.isSameDay = isSameDay;
const toMidnight = dateLike => {
  const date = (0, exports.toDate)(dateLike);
  return new Date(date.setHours(0, 0, 0, 0));
};
exports.toMidnight = toMidnight;
const formatDate = function (dateLike) {
  let dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : exports.DATE_FORMATS['YEAR_MONTH_DAY_FORMAT'];
  if (!dateLike) {
    return '';
  }
  const date = (0, exports.toDate)(dateLike);
  return (0, format_1.default)(date, dateFormat);
};
exports.formatDate = formatDate;
const getListOfMonths = dateLike => {
  const date = (0, exports.toDate)(dateLike);
  const year = date.getFullYear(); // Set the year you need the months for
  const start = (0, exports.startOfYear)(new Date(year, 0));
  const end = (0, exports.endOfYear)(new Date(year, 0));
  return (0, eachMonthOfInterval_1.default)({
    start,
    end
  });
};
exports.getListOfMonths = getListOfMonths;
const setDayOfWeek = (dateLike, dayOfWeek) => {
  const date = (0, exports.toDate)(dateLike);
  const currentDay = date.getDay();
  const difference = dayOfWeek - currentDay;
  date.setDate(date.getDate() + difference);
  return date;
};
exports.setDayOfWeek = setDayOfWeek;
const set = (dateLike, object) => {
  const date = (0, exports.toDate)(dateLike);
  return (0, set_1.default)(date, object);
};
exports.set = set;
const getDayLabel = noOfDays => {
  if (!noOfDays || noOfDays < 0) {
    return '0 Days';
  }
  if (noOfDays === 1) {
    return "".concat(noOfDays, " Day");
  }
  return "".concat(noOfDays, " Days");
};
exports.getDayLabel = getDayLabel;
const rangesOverlaps = (rangeA, rangeB) => {
  return (0, exports.isSameOrBefore)((0, max_1.default)([(0, exports.toDate)(rangeA.start), (0, exports.toDate)(rangeB.start)]), (0, min_1.default)([(0, exports.toDate)(rangeA.end), (0, exports.toDate)(rangeB.end)]));
};
exports.rangesOverlaps = rangesOverlaps;